import {
  CLINICIAN_ROLES,
  IAdvanceSearchFilter,
  IGroupInfoMembers,
  ISuggestedClinicianDepartmentId,
} from "@home-health-notify/domain";
import {
  buildClinicianRoleFilters,
  buildExistingMembersWithUserInfo,
  buildServicesToPatientFilters,
  DISTANCE_IN_MILES,
  getDisciplineByDepartmentId,
  getFilterByDisciplinesOrder,
  IOrganizationContext,
  OrganizationContext,
  UserDirectoryContext,
} from "hhn-commons";
import { useContext } from "react";
import { ClinicianMapDialog } from "../../../common/clinicianMapDialog/ClinicianMapDialog";
import AdvanceSearchHeaderContent from "./AdvanceSearchHeaderContent";
import { IPatientHeaderProps } from "./AdvanceSearchHelper";
import { PatientPinContent } from "./map/PatientPinContent";

export type AdvanceSearchDialogProps = {
  open: boolean;
  closeModal: () => void;
  advanceSearchFilters: IAdvanceSearchFilter;
  existingMembers?: IGroupInfoMembers[];
  existingGroup?: boolean;
  patientHeaderProps: IPatientHeaderProps;
  suggestedCliniciansDepartments?: ISuggestedClinicianDepartmentId[];
  searchRadius?: DISTANCE_IN_MILES;
  onAddMemberCallback: (selectedMembers: any) => void;
};

export const AdvanceSearchDialog = ({
  open,
  closeModal,
  advanceSearchFilters,
  existingMembers = [],
  existingGroup,
  patientHeaderProps,
  suggestedCliniciansDepartments = [],
  searchRadius,
  onAddMemberCallback,
}: AdvanceSearchDialogProps) => {
  const { selectedOrgUser }: IOrganizationContext =
    useContext(OrganizationContext);
  const { userDirectory } = useContext(UserDirectoryContext);

  const departments = selectedOrgUser?.getDepartments() || [];

  const existingMembersWithUserInfo = buildExistingMembersWithUserInfo(
    existingMembers,
    userDirectory.getUserInfo.bind(userDirectory),
  );

  const clinicianRoles = buildClinicianRoleFilters(departments);
  const servicesToPatient = buildServicesToPatientFilters(
    patientHeaderProps.servicesToPatient,
  );

  const suggestedDiscipline = getDisciplineByDepartmentId(
    suggestedCliniciansDepartments[0],
    departments,
  );

  const filterByDisciplinesOrder = getFilterByDisciplinesOrder(
    clinicianRoles,
    servicesToPatient,
    existingMembersWithUserInfo,
  );

  const disciplineToBeSelected =
    filterByDisciplinesOrder?.disciplineToBeSelected || CLINICIAN_ROLES.SN;
  const disciplinesFilters =
    filterByDisciplinesOrder?.disciplinesFilters || [];

  return (
    <ClinicianMapDialog
      open={open}
      closeModal={closeModal}
      title="advanceSearch"
      testId="advance-search-dialog"
      advanceSearchFilters={advanceSearchFilters}
      headerContent={
        <AdvanceSearchHeaderContent
          patientHeaderProps={patientHeaderProps}
          existingMembers={existingMembers}
        />
      }
      centerPinContent={
        <PatientPinContent patientHeaderProps={patientHeaderProps} />
      }
      disciplinesFilters={disciplinesFilters}
      initialDiscipline={
        suggestedDiscipline || disciplineToBeSelected || CLINICIAN_ROLES.SN
      }
      initialDistance={searchRadius || DISTANCE_IN_MILES.TWO}
      showActions={true}
      existingMembers={existingMembers}
      existingGroup={existingGroup}
      enableReferrals={true}
      onAddMemberCallback={onAddMemberCallback}
    />
  );
};
